<template>
  <Transition name="modal1">
    <div v-if="props.optionsNotifications.showModal1" id="modalNotification">
      <div class="notification">
        <img
          src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
          alt="Close"
          @click="emits('closeNotification')"
          class="close-modal"
        />
        <div class="notification-divs">
          <div class="notification-div-left">
            <img :src="IconeBds" alt="Icone BDS" />
          </div>
          <div class="generic-modal-addons notification-div-right">
            <span class="notification-title">{{
              translate.notificationTitle
            }}</span
            ><br />
            <span
              class="notification-text"
              v-html="translate.notificationText"
            ></span
            ><br />
            <input
              type="button"
              class="notification-btn-allow"
              @click="emits('subscribeShowPrompt')"
              :value="translate.notificationButtonAllow"
            />&nbsp;&nbsp;
            <input
              type="button"
              class="notification-btn-not-allow"
              @click="emits('closeNotification')"
              :value="translate.notificationButtonNotAllow"
            />
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <Transition name="modal2">
    <div v-if="props.optionsNotifications.showModal2">
      <div class="notification-check">
        <img
          src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
          alt="Close"
          @click="emits('closeNotificationCheckBar')"
          class="close-modal-check"
        />
        <br />
        {{ translate.notificationCheck }}
      </div>
    </div>
  </Transition>

  <Transition name="modal3">
    <div v-if="props.optionsNotifications.showModal3">
      <div class="notification-status">
        <img
          src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
          alt="Close"
          @click="emits('closeNotificationStatus')"
          class="close-modal"
        />
        <span v-html="translate.notificationMsgStatus"></span>
      </div>
    </div>
  </Transition>

  <NotificationBell
    v-if="props.optionsNotifications.showBell"
    :texto-da-lixeira="translate.notificationBellRemove"
    @ativar="emits('checkNotificationStatus')"
    @remover="emits('removeBell')"
  />
</template>

<script lang="ts" setup>
import notificationTradutor from "@/tradutors/notification";
import NotificationBell from "@/components/Modais/NotificationBell.vue";
import IconeBds from "assets/img/icone_BDS.png";

const route = useRoute();

const props = defineProps(["optionsNotifications"]);
const emits = defineEmits([
  "closeNotification",
  "closeNotificationCheckBar",
  "subscribeShowPrompt",
  "checkNotificationStatus",
  "closeNotificationStatus",
  "removeBell",
]);

const translate = computed(() =>
  route.params.language === "pt-br"
    ? notificationTradutor.portugues
    : notificationTradutor.ingles
);
</script>

<style scoped>
.notification {
  width: 475px;
  padding-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 5px 5px 10px #cccccc;
  z-index: 998;
  position: fixed;
  top: 85px;
  left: 50px;
  border-radius: 5px;
}

.notification-divs {
  display: flex;
}

.notification-div-left {
  width: 30%;
  text-align: center;
}

.notification-div-right {
  width: 70%;
  text-align: left;
  margin-top: 20px;
}

.notification-div-left img {
  margin-top: 30px;
  width: 85px;
}

.notification-btn-allow {
  background-color: #6ca727;
  border: 0px;
  padding: 5px 30px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
}

.notification-btn-not-allow {
  background-color: #f2f2f2;
  border: 0px;
  padding: 5px 30px;
  border-radius: 10px;
  color: #1d1d1d;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
}

.notification-title {
  font-size: 17px;
  font-weight: bold;
  font-family: Open Sans, Roboto, Arial, Helvetica, sans-serif, SimSun;
  color: #1d1d1d;
}

.notification-text {
  font-size: 15px;
  font-family: Open Sans, Roboto, Arial, Helvetica, sans-serif, SimSun;
  color: #1d1d1d;
  margin-bottom: 30px;
}

.notification-check {
  margin: 0 auto;
  background: #f2f2f2;
  line-height: 1.6em;
  border-radius: 15px;
  width: 300px;
  height: auto;
  color: #000000;
  font-family: "Exo 2", sans-serif;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 30px;
  position: fixed;
  z-index: 9998;
  margin-top: 30px;
  left: 50%;
  margin-left: -200px;
  top: -10px;
  box-shadow: 5px 5px 10px #cccccc;
}

.notification-check:after {
  /*Triangulo*/
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #f2f2f2;
  top: -20px;
  left: 45%;
}

.notification-status {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #ffffff;
  font-size: 20px;
  padding: 30px;
  text-align: center;
  box-shadow: 5px 5px 10px #cccccc;
  border-radius: 5px;
}

.close-modal {
  cursor: pointer;
  position: absolute;
  left: 93.6%;
  top: 4px;
  z-index: 1;
}

.close-modal-check {
  cursor: pointer;
  position: absolute;
  left: 90.6%;
  top: 4px;
  z-index: 1;
}

/* regras mobile 650vp */
@media screen and (max-width: 650px) {
  .notification {
    top: 80px;
    left: 10px;
    width: 95%;
  }
  .notification-div-left {
    width: 20%;
  }
  .notification-div-right {
    width: 80%;
  }
  .notification-div-left img {
    width: 50px;
  }
  .notification-title {
    font-size: 15px;
  }
  .notification-text,
  .notification-btn-allow,
  .notification-btn-not-allow {
    font-size: 13px;
  }
  .close-modal {
    left: 88.6%;
    width: 35px;
    height: 35px;
  }
  .notification-btn-allow,
  .notification-btn-not-allow {
    padding: 5px 20px;
  }
  .notification-status {
    width: 95%;
  }
}
</style>
